import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for ResourceStore, for use in the registry */ export const GroundingResourceStoreActionTypes = [
    ActionType.CreateGroundingResourceItem,
    ActionType.CreateGroundingResourceItemFailed,
    ActionType.CreateGroundingResourceItemSucceeded,
    ActionType.DeleteGroundingResourceItem,
    ActionType.DeleteGroundingResourceItemFailed,
    ActionType.DeleteGroundingResourceItemSucceeded,
    ActionType.FetchAttachedGroundingResourceItemsForPlan,
    ActionType.FetchAttachedGroundingResourceItemsForPlanFailed,
    ActionType.FetchAttachedGroundingResourceItemsForPlanSucceeded,
    ActionType.FetchRecentGroundingResourceItemsForPlan,
    ActionType.FetchRecentGroundingResourceItemsForPlanFailed,
    ActionType.FetchRecentGroundingResourceItemsForPlanSucceeded,
    ActionType.InitializeEsdkForResourcesSucceeded
];
